import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'devicon/devicon.min.css';

import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

// Initialize dayjs plugins globally
dayjs.extend(localizedFormat);

// Patch ResizeObserver to defer callbacks via requestAnimationFrame.
// This prevents the "ResizeObserver loop completed with undelivered notifications"
// error that @xyflow/react's NodeResizer can trigger during rapid resizing.
const _OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class PatchedResizeObserver extends _OriginalResizeObserver {
	constructor(callback: ResizeObserverCallback) {
		super((entries, observer) => {
			requestAnimationFrame(() => callback(entries, observer));
		});
	}
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
